import { render, staticRenderFns } from "./QcDigit.vue?vue&type=template&id=248268a6&scoped=true"
import script from "./QcDigit.vue?vue&type=script&lang=js"
export * from "./QcDigit.vue?vue&type=script&lang=js"
import style0 from "./QcDigit.vue?vue&type=style&index=0&id=248268a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248268a6",
  null
  
)

export default component.exports